import superagent from 'superagent'

const elevation = {
  getElevation: (lat, lng, token) => {
    return new Promise((resolve, reject) => {
      // make sure to parse the value and confirm if valid
      const latitud = Number(lat)
      const longitud = Number(lng)
      if (latitud && longitud) {
        superagent
          .get(`${__API_URI__}/Elevation/Get?Latitude=${lat}&Longitude=${lng}`)
          .set('Authorization', `Bearer ${token}`)
          .set('content-type', 'application/json')
          .set('Platform', 'Web')
          .set('Version', `${__version__}`)
          .end((err, res) => {
            if (err) {
              reject(err)
            } else {
              resolve(res.body)
            }
          })
      } else {
        reject()
      }
    })
  },

  // Batch elevation lookup: points is [{lat, lng}, ...]; resolves an array of
  // altitudes (meters) aligned to the input order.
  getElevations: (points, token) => {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(points) || points.length === 0) {
        reject()
        return
      }
      superagent
        .post(`${__API_URI__}/Elevation/Get`)
        .send(points.map(p => ({ latitude: p.lat, longitude: p.lng })))
        .set('Authorization', `Bearer ${token}`)
        .set('content-type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve((res.body || []).map(p => p.altitude))
          }
        })
    })
  }
}

export default elevation